import { render, staticRenderFns } from "./CoursewareLinkBlock.vue?vue&type=template&id=4b20ef2e&scoped=true&"
import script from "./CoursewareLinkBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareLinkBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareLinkBlock.vue?vue&type=style&index=0&id=4b20ef2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20ef2e",
  null
  
)

export default component.exports